// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__DM_Sans_aa94b5', '__DM_Sans_Fallback_aa94b5'","fontStyle":"normal"},"className":"__className_aa94b5","variable":"__variable_aa94b5"};